import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';
import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'Außerhalb WZF',
  label: 'Außerhalb WZF',
  positiveDirection: PositiveDirection.custom,
  valueFormat: '-#.###.##',
});
